import { render, staticRenderFns } from "./MonthlyTaxes.vue?vue&type=template&id=bc834806"
import script from "./MonthlyTaxes.vue?vue&type=script&lang=js"
export * from "./MonthlyTaxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports